const daysSinceReleaseLimitOptions = [
  { id: '2', label: 'Minder dan 2 dagen' },
  { id: '7', label: 'Minder dan 7 dagen' },
  { id: '30', label: 'Minder dan 1 maand' },
];

const checkboxFilterLabels = {
  bicycleAllowance: 'Fietsvergoeding',
  companyOrLeaseBikes: 'Bedrijfs- of leasefietsen',
  chargingStationEBikes: 'Oplaadpunt e-bikes',
  changingRoomAndOrShowers: 'Kleedkamer en/of douches',

  refundBusTrain: 'Terugbetaling bus of trein',
  organizationCollectiveTransport: 'Organisatie collectief vervoer',
  
  telecommutingIsPossible: 'Telewerken kan',
  flexibleHours: 'Glijdende uren',

  organizationCarpool: 'Organisatie carpool',
  carSharingSubscription: 'Abonnement autodelen',
  electricCarChargingStation: 'Oplaadpunt elektrische wagen',
  companyCar: 'Bedrijfswagen',
};

const languageLevels = [
  { id: '40', label: 'helemaal niet' },
  { id: '41', label: 'in beperkte mate' },
  { id: '42', label: 'goed' },
  { id: '43', label: 'zeer goed' },
];

export {
  daysSinceReleaseLimitOptions,
  checkboxFilterLabels,
  languageLevels,
};
